import type { SvgIconComponent } from "@mui/icons-material";
import HomeIcon from "@mui/icons-material/Home";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import SettingsIcon from "@mui/icons-material/Settings";
// import BarChartIcon        from '@mui/icons-material/BarChart';

interface NavBarItem {
  name: string;
  href: string;
  Icon: SvgIconComponent;
  adminOnly?: boolean;
}

export const navbarData: NavBarItem[] = [
  { name: "Home", href: "/", Icon: HomeIcon },
  { name: "Diagnosis", href: "/diagnostic", Icon: MedicalServicesIcon },
  {
    name: "Case Management",
    href: "/cases",
    Icon: FolderOpenIcon,
    adminOnly: true,
  },
  { name: "Admin", href: "/admin", Icon: SettingsIcon, adminOnly: true },
  // { name: 'Statistics',  href: '/statistics', Icon: BarChartIcon },
];
